import axios from "~/utils/api";

const businessTypeApi = {
  get: () => axios.get("business-type"),
};

export default businessTypeApi;
